/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Activity_SprayingInputs */

const vi_care_log_activity_spraying = /** @type {(inputs: Care_Log_Activity_SprayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phun thuốc`)
};

/**

* @param {Care_Log_Activity_SprayingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_activity_spraying = /** @type {((inputs?: Care_Log_Activity_SprayingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Activity_SprayingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_activity_spraying(inputs)
});